import RouteView from "@/layouts/RouteView.vue";
export default {
  path: "/report",
  name: "report",
  redirect: "/report/Index",
  component: RouteView,
  meta: {
    title: "报表",
    icon: "list-o",
    showNavBar: false,
  },
  children: [
    {
      path: "/report/List",
      name: "ReportList",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/report/List.vue"),
      meta: {
        title: "报表中心",
      },
    },
    {
      path: "/report/Index",
      name: "ReportIndex",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/report/Index.vue"),
      meta: {
        title: "报表",
      },
    },
  ],
};
